<template>
  <el-select :value="value" v-bind="$attrs" v-on="$listeners">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'SortSelect',
  props: {
    value: {
      required: true,
    },
    params: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      options: [],
    }
  },
  watch: {
    params: {
      handler() {
        this._loadData()
      },
      immediate: true,
    },
  },
  methods: {
    _loadData() {
      if (this.params == null) {
        this.options = []
      } else {
        this.options = this.params
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
